var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "table",
      { staticClass: "table text-sm" },
      [
        _c("thead", [
          _c(
            "tr",
            [
              _vm._l(_vm.tableDefs.columns, function (column) {
                return _c(
                  "th",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: column.hide == null || column.hide == false,
                        expression:
                          "column.hide == null || column.hide == false",
                      },
                    ],
                    key: column.key,
                    class: [
                      { filtered: column.activeFilter || column.activeSort },
                      { filterable: column.sortable || column.filter },
                    ],
                    style: { minWidth: column.minWidth },
                    attrs: { width: column.width },
                  },
                  [
                    _vm.handleRendererComponent(column.label)
                      ? _c(column.label, {
                          directives: [
                            {
                              name: "dynamic-events",
                              rawName: "v-dynamic-events",
                              value: _vm.knownEvents,
                              expression: "knownEvents",
                            },
                          ],
                          tag: "component",
                          attrs: { "table-data": _vm.tableDataObject },
                        })
                      : _c("span", {
                          domProps: { innerHTML: _vm._s(column.label) },
                        }),
                    _vm._v(" "),
                    column.showTooltip
                      ? _c(
                          "div",
                          { staticClass: "tableColumn-tooltip-wrapper" },
                          [
                            _c("i", {
                              staticClass:
                                "fa fa-info-circle text-light warning-beepiz-remote-monitoring show",
                              staticStyle: {
                                "font-size": "1rem",
                                "margin-left": "10px",
                                cursor: "pointer",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "tooltip top",
                                staticStyle: {
                                  width: "250px",
                                  right: "-5px",
                                  top: "calc(100% + 0.75rem + 12px)",
                                },
                              },
                              [
                                _c(
                                  "h5",
                                  {
                                    staticStyle: {
                                      color: "#ffc107",
                                      "font-weight": "700",
                                    },
                                  },
                                  [_vm._v(_vm._s(column.tooltipTitle))]
                                ),
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(column.tooltipContent) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    column.sortable || column.filter
                      ? _c("i", { staticClass: "fa fa-arrows-v" })
                      : _vm._e(),
                    _vm._v(" "),
                    column.sortable || column.filter
                      ? _c("i", {
                          staticClass: "fa fa-cog",
                          on: {
                            click: function ($event) {
                              return _vm.popupHandler(column)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    (column.sortable || column.filter) && column.showPopup
                      ? _c("TableFilterPopup", {
                          attrs: { columnData: column },
                          on: {
                            sort: _vm.handleSort,
                            filter: _vm.handleFilter,
                            close: _vm.popupHandler,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.tableDefs.rowActions.actions ? _c("th") : _vm._e(),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _vm.tableDataObject && _vm.tableDataObject.length > 0 && !_vm.loading
          ? _c(
              "draggable",
              {
                attrs: {
                  list: _vm.tableDataObject,
                  element: "tbody",
                  options: _vm.options,
                },
                on: { end: _vm.handleEnd },
              },
              _vm._l(_vm.tableDataObject, function (item) {
                return _c(
                  "tr",
                  [
                    _vm._l(_vm.tableDefs.columns, function (column) {
                      return _c(
                        "td",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                column.hide == null || column.hide == false,
                              expression:
                                "column.hide == null || column.hide == false",
                            },
                          ],
                          key: column.key,
                          class: [
                            column.className,
                            _vm.getSpRowClassname(item),
                          ],
                          attrs: { width: column.width },
                          on: {
                            click: function ($event) {
                              return _vm.onClickCell(column, item)
                            },
                          },
                        },
                        [
                          _vm.handleRendererComponent(column.renderer)
                            ? _c(column.renderer, {
                                directives: [
                                  {
                                    name: "dynamic-events",
                                    rawName: "v-dynamic-events",
                                    value: _vm.knownEvents,
                                    expression: "knownEvents",
                                  },
                                ],
                                tag: "component",
                                attrs: { object: item, columnKey: column.key },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.handleRendererFunction(column.renderer)
                            ? _c("span", {
                                style: column.style,
                                domProps: {
                                  innerHTML: _vm._s(column.renderer(item)),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          column.linkTo && !column.renderer
                            ? _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: _vm.parseLink(column.linkTo, item),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.accessValue(item, column.key))
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !column.renderer &&
                          !column.linkTo &&
                          !_vm.displayIcon(item.type, column.key)
                            ? _c(
                                "span",
                                {
                                  attrs: {
                                    title: _vm.createReceiversList(
                                      item.receivers,
                                      column
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.accessValue(item, column.key)
                                      ) +
                                      "\n                  "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.displayIcon(item.type, column.key)
                            ? _c("i", {
                                class:
                                  "fa fa-" +
                                  _vm.displayIcon(item.type, column.key) +
                                  "  fa-fw",
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _vm.tableDefs.rowActions.actions
                      ? _c(
                          "td",
                          {
                            class: _vm.getSpRowClassname(item),
                            attrs: { width: _vm.tableDefs.rowActions.width },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "actions d-flex" },
                              _vm._l(
                                _vm.tableDefs.rowActions.actions,
                                function (action) {
                                  return _c("router-link", {
                                    key: action.label,
                                    class: action.class,
                                    attrs: {
                                      tag: "i",
                                      to: _vm.parseLink(action.linkTo, item),
                                      title: action.label,
                                      tabindex: "0",
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.onClickAction(action, item)
                                      },
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.loading &&
        (_vm.tableDataObject.length == 0 || !_vm.tableDataObject)
          ? _c("tbody", [
              _c("tr", { staticClass: "no-content" }, [
                _vm.tableDefs.global && _vm.tableDefs.global.noItemsMsg
                  ? _c("td", {
                      attrs: { colspan: _vm.nbColumns },
                      domProps: {
                        innerHTML: _vm._s(_vm.tableDefs.global.noItemsMsg),
                      },
                    })
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.loading
      ? _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "center",
              width: "100%",
            },
          },
          [
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("b-spinner", {
                  staticClass: "mr-auto",
                  staticStyle: { "margin-right": "7px" },
                }),
                _vm._v(" "),
                _c(
                  "strong",
                  {
                    staticStyle: { "margin-left": "10px", "margin-top": "5px" },
                  },
                  [_vm._v(_vm._s(_vm.$t("global.loading")))]
                ),
              ],
              1
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }